module.exports = __webpack_public_path__ + "static/media/exclamation-yellow.6211a8d7.svg";